export const ShortCuts = {
    k : '/',
    x : '/view-vendors',
    u : '/view-customer',
    p : '/customer-preference',
    f : '/follow-up',
    o : '/create-purchase-order',
    l : '/view-purchase-order',
    q : '/view-previous-order',
    n : '/podelivery',
    r : '/view-complain',
    i : '/create-invoice',
    v : '/view-invoice',
    t : '/viewNotice',
    e : '/view-notification',
    s : '/view-sucess-notification',
    m : '/eventCalender',
    d : '/phonebook',
    b : '/viewRemindersPage',
    K : '/',
    X : '/view-vendors',
    U : '/view-customer',
    P : '/customer-preference',
    F : '/follow-up',
    O : '/create-purchase-order',
    L : '/view-purchase-order',
    Q : '/view-previous-order',
    N : '/podelivery',
    R : '/view-complain',
    I : '/create-invoice',
    V : '/view-invoice',
    T : '/viewNotice',
    E : '/view-notification',
    S : '/view-sucess-notification',
    M : '/eventCalender',
    D : '/phonebook',
    B : '/viewRemindersPage',
}